/**
 * MCQ Set content type package
 */

import pkgJson from '../package.json';

export const VERSION = pkgJson.version;
export const PKG_NAME = pkgJson.name;

export {
    mcqSetSchema,
    defaultMCQSetConfig,
    defaultMCQSetData,
    defaultMCQSetI18n,
    createMcqSetItem,
    type MCQSetContent,
    type MCQSetData,
    type MCQSetConfig,
    type MCQSetLayoutConfig,
    type MCQSetScoringConfig,
    type MCQSetItem,
    type ItemLayout,
} from './schema';

export {
    mcqSetContentGrader,
    computeMCQSetResults,
    validateMCQSetAnswer,
    gradeMCQSetContent,
    type MCQSetItemResult,
    type MCQSetResults,
} from '@ai-content-hub/content-elements/mcq-set';

export { McqSetEdit, type McqSetEditProps } from './McqSetEdit';
/** @deprecated Use {@link McqSetEdit} */
export { McqSetEdit as MCQSetEdit } from './McqSetEdit';

export { MCQSetPlayer, type MCQSetPlayerProps } from '@ai-content-hub/content-elements/mcq-set';

export { mcqSetSchema as default } from './schema';

export { countMCQSetQuestions, mcqSetQuestionCounter } from './questionCount';
